import { navigate } from "gatsby-link";
import { trackCustomEvent } from "../utils/analytics";
import useExperiment, { getVariantsFromPercent } from "./useExperiment";

export default function usePath1061Redirect(location: Location) {
  const isClientside = typeof window !== "undefined";
  const isOnPath1061 = location.pathname === "/path/1061/1/";
  const isInABTest = useExperiment(
    isOnPath1061 ? location.pathname : "",
    getVariantsFromPercent(5)
  );

  if (!isClientside || !isOnPath1061 || !isInABTest) {
    return false;
  }

  trackCustomEvent({
    category: "Path",
    action: "Redirecting 1061/1 to 1065/1",
    label: location.pathname,
  });
  navigate(
    location.pathname.replace("/path/1061/1", "/path/1065/1") +
      location.search +
      location.hash
  );
  return true;
}
